Attributes of the newly created unposted position profile.
